import { render, staticRenderFns } from "./demandCard.vue?vue&type=template&id=51b3e676&scoped=true&"
import script from "./demandCard.vue?vue&type=script&lang=js&"
export * from "./demandCard.vue?vue&type=script&lang=js&"
import style0 from "./demandCard.vue?vue&type=style&index=0&id=51b3e676&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3e676",
  null
  
)

export default component.exports